export const getCampusSectionsStorageKey = (campusId) => `sections_${campusId}`;

export const normalizeSectionName = (sectionName) =>
  String(sectionName || "").trim().toUpperCase();

export const getStoredCampusSections = (campusId) => {
  if (!campusId || typeof window === "undefined") return [];

  try {
    const savedSections = window.localStorage.getItem(
      getCampusSectionsStorageKey(campusId),
    );
    const sections = savedSections ? JSON.parse(savedSections) : [];
    if (!Array.isArray(sections)) return [];

    const sectionNames = sections
      .map((section) =>
        normalizeSectionName(
          typeof section === "string" ? section : section?.section_name,
        ),
      )
      .filter(Boolean);

    return [...new Set(sectionNames)].sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }),
    );
  } catch (error) {
    console.error("Failed to read campus sections", error);
    return [];
  }
};
